import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SearchIcon } from "../../../../Utils/SvgIcons";

import {
  GetAdditionalFilterNetwork,
  getUsageAndCoverageFiltersAction,
  GetNetworkClientCoverageDetails,
} from "../../../../redux/actions/NetworkIntelligenceAction";
import { getAllProviderListNetworkAction } from "../../../../redux/actions/TestPackageNetworkAction";
import WithGoogleApi from "../../../../common/Map/WithGoogleApi";
import ReactGoogleAutocomplete from "react-google-autocomplete";
import {
  getCityNameAction,
  getStateNameAction,
} from "../../../../redux/actions/GlobalAction";
import { initialStateCoverage } from "../UsageCoverage/helper";
import { GET_TOTAL_COUNT, GET_USSAGECOVERAGE_DETAILS, getMenus, getNetworkMenuId } from "../../../../Utils/types";
import { getDispatch, getSnackbarSuccess } from "../../../../Utils/helper";
import CustomPagination from "../../../../common/CustomPagination";

export const ClientCoverage = () => {
  const dispatch = useDispatch();
  const [searchFilter, setSearchFilter] = useState(initialStateCoverage);

  const mainMenu = getMenus().filter((ele)=>ele?.menuItem?.menuId === 18)
  const data = mainMenu[0]?.subMenus?.filter((ele)=> ele?.menuId === 27)


  const validIbu =data[0]?.informationPermissions?.filter(
    (ele) => ele?.networkInformationToMenuMapId === 53
  );
  const validCbu =data[0]?.informationPermissions?.filter(
    (ele) => ele?.networkInformationToMenuMapId === 54
  );
  const getUsageCoverageDetails = useSelector(
    (state) => state?.NetworkIntelligenceReducer?.getUsageCoverageDetails
  );
  const globalReducer = useSelector((state) => state.globalReducer);

  useEffect(() => {
    dispatch(getStateNameAction());
    getDispatch(GET_TOTAL_COUNT, null, dispatch);
    getDispatch(GET_USSAGECOVERAGE_DETAILS, {}, dispatch);
  }, []);

  const changeHandler = (name, value) => {
    setSearchFilter({ ...searchFilter, [name]: value });
  };

  useEffect(() => {
    if (searchFilter?.state) {
      const temp = globalReducer?.getAllState?.filter(
        (ele) => ele?.stateName === searchFilter?.state
      )?.[0]?.stateId;
      dispatch(getCityNameAction(temp));
    }
  }, [searchFilter?.state]);

  const handleSearch = async () => {
    setSearchFilter({ ...searchFilter, page: 1 });
    if(searchFilter?.pincodeOrCity === "" && searchFilter?.state === ""){
      getSnackbarSuccess("warning","Please Fill the details",dispatch)
    } else {
      dispatch(
        GetNetworkClientCoverageDetails({
          ...searchFilter,
          page: 1,
        })
      );
    }
   
  };

  // useEffect(()=>{
  //   handleClear()
  // },[searchFilter?.BusinessType])

  const handleClear = (value) => {
    setSearchFilter(initialStateCoverage)
    getDispatch(GET_TOTAL_COUNT, null, dispatch);
    getDispatch(GET_USSAGECOVERAGE_DETAILS, {}, dispatch);
  };

  return (
    <div className="right-section p-20">
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row pt-3">
              <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                <div className="d-flex justify-content-between">
                  <h4>Search Network </h4>
                </div>
                <div className="d-flex flex-wrap gap-10 mt-3">
                  <div className="w-19 my-2">
                    <WithGoogleApi>
                      <ReactGoogleAutocomplete
                        className="form-select h-60"
                        apiKey="AIzaSyAy9gYbxqSCIe2BFo46GcNAk81zP-t7ZGA"
                        onPlaceSelected={(place) =>
                          changeHandler(
                            "pincodeOrCity",
                            place.formatted_address
                          )
                        }
                        onChange={(e) => {
                          setSearchFilter({
                            ...searchFilter,
                            pincodeOrCity: e.target.value,
                            distanceInKms: e.target.value?.length ? 10 : 0,
                          });
                        }}
                        value={searchFilter?.pincodeOrCity}
                        types={["geocode", "establishment"]}
                        inputComponent="input"
                        defaultValue={null}
                        placeholder="AreaName/PinCode"
                      />
                    </WithGoogleApi>
                  </div>

                  <div className="w-19 my-2">
                    <select
                      name="stateName"
                      value={searchFilter.state}
                      onChange={(e) => {
                        changeHandler("state", e.target.value);
                      }}
                      className="form-select h-60 usagecoverage-search"
                    >
                      <option value="">Select State</option>
                      {globalReducer?.getAllState?.map((ele) => {
                        return (
                          <option value={ele.stateName}>
                            {ele?.stateName}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="w-19 my-2">
                    <select
                      name="city"
                      value={searchFilter.city}
                      onChange={(e) => {
                        changeHandler("city", e.target.value);
                      }}
                      className="form-select h-60 usagecoverage-search"
                    >
                      <option value="">Select City</option>
                      {globalReducer?.getAllCity?.map((e) => {
                        return (
                          <option key={e.cityName} value={e.cityName}>
                            {e.cityName}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  {searchFilter?.pincodeOrCity?.length ? (
                    <div className="w-19 my-2">
                      <select
                        className="form-select h-60"
                        value={searchFilter?.distanceInKms}
                        onChange={(e) =>
                          changeHandler("distanceInKms", e.target.value)
                        }
                      >
                        <option value={5}> 5 Kms </option>
                        <option value={10}>10 Kms</option>
                        <option value={15}>15 Kms</option>
                        <option value={20}>20 Kms</option>
                        <option value={30}>30 Kms</option>
                        <option value={40}>40 Kms</option>
                        <option value={50}>50 Kms</option>
                      </select>
                    </div>
                  ) : null}
                </div>
                <div
                  className="d-flex justify-content-between  pt-4"
                  style={{ height: "58px" }}
                >
                  <div className="d-flex gap-2">
                    <button
                      className="search"
                      type="button"
                      style={{ border: "none" }}
                      onClick={handleSearch}
                    >
                      <a className="sidebar-links">
                        <SearchIcon />
                        <span className="sidebar-link-text">Search</span>
                      </a>
                    </button>
                    <div
                      className="search"
                      type="button"
                      onClick={() =>{
                        handleClear()
                      } }
                    >
                      <a className="sidebar-links">
                        <span className="sidebar-link-text">Clear All</span>
                      </a>
                    </div>
                  </div>
                </div>
                {globalReducer?.getTotalCount !== null &&globalReducer?.getTotalCount !== 0 && <div className="d-flex  mt-2 gap-5 ">
                  <div className="me-5 d-flex gap-1">
                    <p className="results">
                      Total <span>{globalReducer?.getTotalCount}</span> results
                    </p>
                  </div>
                </div>}
                

                {getUsageCoverageDetails?.length === 0 && (
                  <h4 className="mapLoader">
                    Record Not Found
                  </h4>
                )}
                {getUsageCoverageDetails?.length > 0 && (
                  <>
                    {getUsageCoverageDetails?.map((ele, index) => {
                      return (
                        <div className="diagnostic_detailbox" key={index}>
                          <div className="diagnostic_centerbox">
                            <div className="d-flex justify-content-start">
                              <div>
                                <img
                                  style={{ width: "70px", marginRight: "30px" }}
                                  src={ele?.providerLogo}
                                />
                              </div>
                              <div style={{width:"100%"}}>
                                <h5 style={{width:"100%"}}> {ele?.providerName} </h5>
                                <p className="pb-16">{ele?.providerCity}</p>
                                <div
                                  className="progress mb-2"
                                  style={{ visibility: "hidden" }}
                                >
                                  <div
                                    className="progress-bar"
                                    role="progressbar"
                                    style={{
                                      background:
                                        ele?.providerScorePercent >= 0 &&
                                        ele?.providerScorePercent <= 50
                                          ? "linear-gradient(90deg, #ff0101 0%, #ff6b00 100%)"
                                          : ele?.providerScorePercent > 50 &&
                                            ele?.providerScorePercent <= 75
                                          ? "linear-gradient(90deg, #ffb901 0%, #ffe401 100%)"
                                          : "linear-gradient(90deg, #64b161 0%, #31fa2a 100%)",
                                      width: `${ele?.providerScorePercent}%`,
                                    }}
                                    aria-valuenow="50"
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                  ></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </>
                )}
              </div>
              <div className="pagination-row">
                {globalReducer?.getTotalCount !== 0 && (
                  <CustomPagination
                    totalCount={globalReducer?.getTotalCount}
                    perPageData={searchFilter?.rows}
                    searchFilter={searchFilter}
                    setSearchFilter={setSearchFilter}
                    apiCall={GetNetworkClientCoverageDetails}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
